import React from 'react'
import moment from 'moment'
import { useReduxSelector } from '../../hooks'

interface PropsStopAction {
  children?: any
  stopText?: any
}

export const StopAction: React.FC<PropsStopAction> = ({ children, stopText }): JSX.Element => {
  const { data: constants } = useReduxSelector((state) => state.constants)

  return (
    <>
      {moment(constants?.NOW).isBefore(moment(constants?.PROJECT_STOP_ACTION)) ? (
        <>{children}</>
      ) : (
        <>{stopText || undefined}</>
      )}
    </>
  )
}
